import { autobind } from 'core-decorators';
import GenericAuthStore from './__generic-auth-store';
import { computed } from 'mobx';

/**
 * xoyo 登录授权 store
 * e.g.
 * {
     "ua": "daily",
     "status": "error",
     "data": {
       "code": -20101,
       "data": {
         "request_id": "afa070ce50eaf62393ccab9a7e35ff60bb37f35f"
       },
       "status": -20101,
       "msg": "请先登录",
       "message": "请先登录",
       "reason": "require-login"
     }
   }
 */
// noinspection SpellCheckingInspection
@autobind
class XoyoAuthStore extends GenericAuthStore {
  /**
   * 是否需要登录
   * @returns {*|boolean}
   */
  get isLoginRequired() {
    return this.hasLoginError && this.data && this.data.reason === 'require-login';
  }

  /**
   * 获取用户名
   * 如: xsj******001
   * @returns {boolean|*}
   */
  @computed
  get username() {
    return this.hasLogin ? this.data.account : '';
  }

  constructor() {
    // noinspection SpellCheckingInspection
    super({ globalAuthName: 'XOYO_AUTH' });
  }
}

// noinspection SpellCheckingInspection
const xoyoAuthStore = new XoyoAuthStore();
export default xoyoAuthStore;
